import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'
import { apiRequest } from '@/shared/api'
import { TagSuggestionSchema } from '../model/types'

export const tagKeys = {
  all: ['tag'] as const,
  suggestions: (q: string) => ['tag', 'suggestions', q] as const,
}

// Саджесты тегов (ранжированы по usage_count). staleTime — словарь тегов
// меняется редко, дебаунс-ввод не должен дёргать бэк повторно.
export function tagSuggestionsQueryOptions(q: string) {
  return queryOptions({
    queryKey: tagKeys.suggestions(q),
    queryFn: async () => {
      const body = await apiRequest<{ items: unknown[] }>({
        method: 'GET',
        url: '/tags',
        query: { q, limit: 10 },
      })
      return z.array(TagSuggestionSchema).parse(body.items)
    },
    staleTime: 60_000,
  })
}
